import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    root: {
      '& .MuiDialog-paperFullWidth': {
        maxWidth: 885,
        borderRadius: 0,
        minHeight: 480,
      },
      '& .MuiDialog-paperScrollPaper': {
        maxHeight: 'calc(100% - 52px)',
      },
    },
    nameCompany: {
      maxWidth: 250,
      fontSize: 12,
    },
    paginationContainer: {
      display: 'flex',
      alignItems: 'center',
    },
    buttonPaginate: {
      border: 'none',
      margin: '0 6px',
    },
    buttonPointer: {
      cursor: 'pointer',
      margin: '0 6px',
    },
    paginationContent: {
      width: 0,
      padding: '5px 12px',
      border: `1px solid ${palette.lightGray}`,
      cursor: 'pointer',
      display: 'flex',
      color: palette.gray,
      justifyContent: 'center',
      fontWeight: 500,
      height: 'auto',
      margin: '0 5px',
      fontSize: 12,
      borderRadius: '50%',
      fontFamily: 'Roboto',
      transition: 'background-color 250ms',
      '&:hover': {
        background: palette.lightGray,
      },
    },
    buttonActive: {
      background: palette.lightGray,
    },
    yellowHeader: {
      padding: '8px 0px 0px 16px',
      backgroundColor: palette.deepBlue,
    },
    grayHeader: {
      padding: '8px 0px 0px 16px',
      backgroundColor: palette.navSuperAdmin,
    },
    greenHeader: {
      padding: '8px 0px 0px 16px',
      backgroundColor: palette.navAdmin,
    },
    blueHeader: {
      padding: '8px 0px 0px 16px',
      backgroundColor: palette.navOperator,
    },
    headerSearch: {
      padding: 17,
    },
    wrapperTitle: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '0 0 7px',
      padding: 0,
    },
    buttonHeader: {
      fontWeight: 400,
      fontSize: 10,
      alignItems: 'end',
      paddingRight: 20,

      '& > span > span': {
        marginRight: 4,
      },
    },

    content: {
      padding: 0,
    },

    footer: {
      display: 'flex',
      padding: '10px 20px',
      justifyContent: 'flex-end',
      alignItems: 'center',
      borderTop: `1px solid ${palette.borderGray}`,
      marginTop: 10,
    },
    tabs: {
      minHeight: 30,
    },
    tab: {
      padding: 0,
      minHeight: 30,

      '& .MuiTab-wrapper': {
        fontSize: 12,
        color: palette.darkGray,
      },
    },

    likeCell: {
      width: 20,
      textAlign: 'center',
      paddingInline: '20px !important',

      '& svg': {
        fontSize: 14,
        fill: palette.primary.main,
      },
    },

    itemSelected: {
      '& .MuiTableCell-root': {
        fontWeight: 600,
      },
    },

    pagination: {
      marginTop: 20,

      '& .MuiButton-root': {
        minWidth: 0,
        width: 35,
        height: 35,
        borderRadius: 35,
        margin: '0 4px',
        border: `1px solid ${palette.lightGray}`,
      },
    },
    buttonCurrent: {
      backgroundColor: palette.lightGray,
      pointerEvents: 'none',
    },
    buttonCancelPartner: {
      color: palette.blue,
      fontSize: 12,
    },
    buttonClose: {
      marginRight: 15,
      padding: 0,
      color: palette.offWhite,
      '& .MuiSvgIcon-root': {
        height: 16,
        width: 16,
      },
    },
    buttonCloseSuperAdmin: {
      marginRight: 15,
      padding: 0,
      color: palette.lightNavSuperAdminActions,
      '& .MuiSvgIcon-root': {
        height: 16,
        width: 16,
      },
    },
    modalTitle: {
      fontSize: 14,
      fontWeight: 500,
      color: palette.grey200,
    },
    modalTitleSuperAdmin: {
      fontSize: 14,
      fontWeight: 500,
      color: palette.lightNavSuperAdminActions,
    },
    newCompanyIcon: {
      fontSize: '16px !important',
      color: palette.darkGray,
    },
    searchBarIcon: {
      fontSize: 19,
    },
    searchTitle: { fontSize: 12 },
    tableHeader: {
      fontSize: 12,
    },
    shortNameIDCompany: {
      fontSize: 12,
    },
    tableRow: {
      height: 20,
      '& .MuiTableCell-root': {
        padding: 0,
      },
      '&:hover': {
        background: `${palette.superLightDeepBlue} !important`,
        color: palette.darkGray,
        fontWeight: 600,
      },
    },
    tableRowHover: {
      '&:hover': {
        cursor: 'pointer',
        color: palette.darkGray,
        fontWeight: 600,
      },
    },
    newCompany: {
      color: palette.darkGray,
      fontSize: 12,
    },
    buttons: {
      justifyContent: 'flex-end',
      marginLeft: '0px !important',
    },
    iconYellow: {
      color: palette.navCompanyContextActions,
    },
    iconGreen: {
      color: palette.navAdmin,
    },
    iconGray: {
      color: palette.navSuperAdminActions,
    },
    iconBlue: {
      color: palette.navOperator,
    },
    cancelButton: { marginLeft: '0px !important', justifyContent: 'flex-end' },
  });
